module.exports = __webpack_public_path__ + "f6a38f7e972fa634afe7df88be546002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorMIXERS-SUPPLIES.jpg
// module id = 1043
// module chunks = 1